import React from 'react';
import PropTypes from 'prop-types';

import ListWithOverflow from '../../components/list-with-overflow';
import GridTitle from './grid-header-title';
import GridReloadButton from './grid-reload-button';

import OrdersOverflowDropdownContainer from '../../pages/orders-page/containers/grid-header-overflow-dropdown-container';
import { useQuickSearchTerm } from '../../hooks/routing/use-quick-search-term';
import { useIsInDemoStore } from '../../demos/hooks/use-is-in-demo-store';
import { useIsQuickshipEnabled } from '../../hooks/use-user-setting';
import QuickshipGridTreatment from './quickship-grid-treatment';
import { DemoStoreDeactivateBanner } from '../../demos/demo-store-deactivate-banner';

import style from './grid-header.module.less';
import { ChildrenPropType } from '../../prop-types/children';
import { AutomationRecommendationsBanner } from '../../global/automation-recommendations-banner';

export const GridHeaderWithOverflow = ({
  view,
  onReloadGrid,
  customOverflowDropdown = OrdersOverflowDropdownContainer,
  showReloadButton = false,
  isQuickshipCompatible = false,
  ignoreCustomOverflow = false,
  bannerSlot = null,
  children,
}) => {
  const searchTerm = useQuickSearchTerm();
  const shouldShowQuickshipEnabledState = useIsQuickshipEnabled();
  const isInDemoStore = useIsInDemoStore();

  const hasButtons = view && Array.isArray(view.buttons) && view.buttons.length > 0;

  return (
    <div className={style['grid-header-wrapper']}>
      {isInDemoStore && <DemoStoreDeactivateBanner />}
      <AutomationRecommendationsBanner />

      {isQuickshipCompatible && shouldShowQuickshipEnabledState && <QuickshipGridTreatment />}
      <div className={style['grid-header-container']}>
        <div className={style['view-details-container']}>
          <div className={style['view-name']}>
            <GridTitle searchTerm={searchTerm} view={view} />
          </div>
          {showReloadButton && <GridReloadButton onReloadGrid={onReloadGrid} />}
        </div>
        {children && <div className={style['right-aligned-buttons-container']}>{children}</div>}
      </div>
      {bannerSlot}
      {hasButtons && (
        <div className={style['actions-container']}>
          <ListWithOverflow
            componentOverflowDisplayPropName='overflowName'
            componentsToRender={view.buttons}
            customOverflowDropdown={customOverflowDropdown}
            ignoreCustomOverflow={ignoreCustomOverflow}
            overflowToggleInVisibleContainer
            requiredRenderIndices={view.requiredRenderIndices}
          />
        </div>
      )}
    </div>
  );
};

GridHeaderWithOverflow.propTypes = {
  view: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    getLabel: PropTypes.func,
    buttons: PropTypes.arrayOf(PropTypes.element).isRequired,
    requiredRenderIndices: PropTypes.arrayOf(PropTypes.number),
    id: PropTypes.string.isRequired,
  }).isRequired,
  onReloadGrid: PropTypes.func,
  customOverflowDropdown: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  showReloadButton: PropTypes.bool,
  isQuickshipCompatible: PropTypes.bool,
  ignoreCustomOverflow: PropTypes.bool,
  bannerSlot: PropTypes.node,
  children: ChildrenPropType,
};
